import { Buffer } from 'buffer'

import { joinURL } from 'ufo'
import { createOperationsGenerator, defineProvider } from '@nuxt/image/runtime'

const operationsGenerator = createOperationsGenerator({
    keyMap: {
        resize: 'rs',
        size: 's',
        fit: 'rt',
        width: 'w',
        height: 'h',
        dpr: 'dpr',
        enlarge: 'el',
        extend: 'ex',
        gravity: 'g',
        crop: 'c',
        padding: 'pd',
        trim: 't',
        rotate: 'rot',
        quality: 'q',
        maxBytes: 'mb',
        background: 'bg',
        backgroundAlpha: 'bga',
        blur: 'bl',
        sharpen: 'sh',
        watermark: 'wm',
        preset: 'pr',
        cacheBuster: 'cb',
        stripMetadata: 'sm',
        stripColorProfile: 'scp',
        autoRotate: 'ar',
        filename: 'fn',
        format: 'f'
    },
    formatter: (key: string, value: string | number) => `${key}:${value}`,
    joinWith: '/'
})

function urlSafeBase64 (string: string) {
    return Buffer.from(string, 'utf8')
        .toString('base64')
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
}

const defaultModifiers = {
    fit: 'fill',
    width: 0,
    height: 0,
    gravity: 'no',
    enlarge: 1,
    format: 'webp'
}

interface ImgProxyProviderOptions {
    modifiers: Record<string, unknown>
    imgProxyUrl: string
}

export default defineProvider({
    getImage: (src, options) => {
        const { modifiers, imgProxyUrl } = options as unknown as ImgProxyProviderOptions
        const mergeModifiers = { ...defaultModifiers, ...modifiers } as unknown as { [key: string]: string }
        const encodedUrl = urlSafeBase64(src)
        const path = joinURL('/', operationsGenerator(mergeModifiers), encodedUrl)
        const signature = '_' //sign(imgProxySalt, path, imgProxyKey)

        return {
            url: joinURL(imgProxyUrl, signature, path)
        }
    }
})
